/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.AreaElevationRequest = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The AreaElevationRequest model module.
   * @module model/AreaElevationRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>AreaElevationRequest</code>.
   * The request object includes the Well Known Text (WKT), srid, the distance of interval points, the unit of distance and the unit of the elevation.
   * @alias module:model/AreaElevationRequest
   * @class
   * @param wellKnownText {String} Required. The Well Known Text (WKT) of the feature to get the elevation from.
   */
  var exports = function(wellKnownText) {
    var _this = this;

    _this['wellKnownText'] = wellKnownText;




  };

  /**
   * Constructs a <code>AreaElevationRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AreaElevationRequest} obj Optional instance to populate.
   * @return {module:model/AreaElevationRequest} The populated <code>AreaElevationRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('wellKnownText')) {
        obj['wellKnownText'] = ApiClient.convertToType(data['wellKnownText'], 'String');
      }
      if (data.hasOwnProperty('srid')) {
        obj['srid'] = ApiClient.convertToType(data['srid'], 'Number');
      }
      if (data.hasOwnProperty('intervalDistance')) {
        obj['intervalDistance'] = ApiClient.convertToType(data['intervalDistance'], 'Number');
      }
      if (data.hasOwnProperty('intervalDistanceUnit')) {
        obj['intervalDistanceUnit'] = ApiClient.convertToType(data['intervalDistanceUnit'], 'String');
      }
      if (data.hasOwnProperty('elevationUnit')) {
        obj['elevationUnit'] = ApiClient.convertToType(data['elevationUnit'], 'String');
      }
    }
    return obj;
  }

  /**
   * Required. The Well Known Text (WKT) of the feature to get the elevation from.
   * @member {String} wellKnownText
   */
  exports.prototype['wellKnownText'] = undefined;
  /**
   * The SRID (coordinate system) of the WellKnownText.
   * @member {Number} srid
   */
  exports.prototype['srid'] = undefined;
  /**
   * The distance between every two points in the area matrix. Elevation of each point will be calculated and returned. Defaults to 1000.0. The unit of measure for this distance is specified by the <para>IntervalDistanceUnit</para> parameter.
   * @member {Number} intervalDistance
   */
  exports.prototype['intervalDistance'] = undefined;
  /**
   * The unit of measure in which the IntervalDistance is expressed. Defaults to \"Feet\".
   * @member {module:model/AreaElevationRequest.IntervalDistanceUnitEnum} intervalDistanceUnit
   */
  exports.prototype['intervalDistanceUnit'] = undefined;
  /**
   * The unit of measure in which the elevation should be expressed.
   * @member {module:model/AreaElevationRequest.ElevationUnitEnum} elevationUnit
   */
  exports.prototype['elevationUnit'] = undefined;


  /**
   * Allowed values for the <code>intervalDistanceUnit</code> property.
   * @enum {String}
   * @readonly
   */
  exports.IntervalDistanceUnitEnum = {
    /**
     * value: "Meter"
     * @const
     */
    "Meter": "Meter",
    /**
     * value: "Feet"
     * @const
     */
    "Feet": "Feet",
    /**
     * value: "Kilometer"
     * @const
     */
    "Kilometer": "Kilometer",
    /**
     * value: "Mile"
     * @const
     */
    "Mile": "Mile",
    /**
     * value: "UsSurveyFeet"
     * @const
     */
    "UsSurveyFeet": "UsSurveyFeet",
    /**
     * value: "Yard"
     * @const
     */
    "Yard": "Yard",
    /**
     * value: "NauticalMile"
     * @const
     */
    "NauticalMile": "NauticalMile",
    /**
     * value: "Inch"
     * @const
     */
    "Inch": "Inch",
    /**
     * value: "Link"
     * @const
     */
    "Link": "Link",
    /**
     * value: "Chain"
     * @const
     */
    "Chain": "Chain",
    /**
     * value: "Pole"
     * @const
     */
    "Pole": "Pole",
    /**
     * value: "Rod"
     * @const
     */
    "Rod": "Rod",
    /**
     * value: "Furlong"
     * @const
     */
    "Furlong": "Furlong",
    /**
     * value: "Vara"
     * @const
     */
    "Vara": "Vara",
    /**
     * value: "Arpent"
     * @const
     */
    "Arpent": "Arpent"  };

  /**
   * Allowed values for the <code>elevationUnit</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ElevationUnitEnum = {
    /**
     * value: "Meter"
     * @const
     */
    "Meter": "Meter",
    /**
     * value: "Feet"
     * @const
     */
    "Feet": "Feet",
    /**
     * value: "Kilometer"
     * @const
     */
    "Kilometer": "Kilometer",
    /**
     * value: "Mile"
     * @const
     */
    "Mile": "Mile",
    /**
     * value: "UsSurveyFeet"
     * @const
     */
    "UsSurveyFeet": "UsSurveyFeet",
    /**
     * value: "Yard"
     * @const
     */
    "Yard": "Yard",
    /**
     * value: "NauticalMile"
     * @const
     */
    "NauticalMile": "NauticalMile",
    /**
     * value: "Inch"
     * @const
     */
    "Inch": "Inch",
    /**
     * value: "Link"
     * @const
     */
    "Link": "Link",
    /**
     * value: "Chain"
     * @const
     */
    "Chain": "Chain",
    /**
     * value: "Pole"
     * @const
     */
    "Pole": "Pole",
    /**
     * value: "Rod"
     * @const
     */
    "Rod": "Rod",
    /**
     * value: "Furlong"
     * @const
     */
    "Furlong": "Furlong",
    /**
     * value: "Vara"
     * @const
     */
    "Vara": "Vara",
    /**
     * value: "Arpent"
     * @const
     */
    "Arpent": "Arpent"  };


  return exports;
}));



